export default function getDifferenceInMinutes(date1: string, date2: string) {
  const diff = Math.abs(Number(new Date(date1)) - Number(new Date(date2)))
  const minutes = Math.floor(diff / 1000 / 60)
  return minutes
}
